<script setup>
import { computed } from 'vue'
import { Check } from 'lucide-vue-next'
import { Button } from '@/components/ui/button'

const props = defineProps({
  plan: {
    type: Object,
    required: true
  },
  isCurrentPlan: {
    type: Boolean,
    default: false
  },
  showUpgradeButton: {
    type: Boolean,
    default: true
  }
})

const emit = defineEmits(['upgrade'])

const formatLimit = (limit) => {
  return limit === null ? 'Unlimited' : limit.toString()
}

const handleUpgrade = () => {
  emit('upgrade', props.plan.key)
}
</script>

<template>
  <div 
    :class="[
      'relative border rounded-lg p-6 h-full flex flex-col',
      isCurrentPlan ? 'ring-2 ring-primary' : ''
    ]"
  >
    <!-- Header -->
    <div class="text-center mb-4">
      <h3 class="font-semibold text-lg capitalize">{{ plan.name }}</h3>
      <p class="text-sm text-muted-foreground">{{ plan.description }}</p>
    </div>

    <!-- Price -->
    <div class="text-center mb-6">
      <span class="text-3xl font-bold">${{ plan.price_monthly }}</span>
      <span class="text-muted-foreground"> / month</span>
    </div>

    <!-- Features -->
    <div class="space-y-3 mb-6 flex-grow">
      <div class="flex justify-between items-center">
        <span class="text-sm">Max Projects:</span>
        <span class="font-medium">{{ formatLimit(plan.max_projects) }}</span>
      </div>
      <div class="flex justify-between items-center">
        <span class="text-sm">Team Members:</span>
        <span class="font-medium">{{ formatLimit(plan.max_team_members) }}</span>
      </div>
    </div>

    <!-- Action Button -->
    <div v-if="showUpgradeButton">
      <Button
        v-if="isCurrentPlan"
        variant="outline"
        class="w-full"
        disabled
      >
        <Check class="h-4 w-4 mr-2" />
        Current Plan
      </Button>
      <Button
        v-else
        @click="handleUpgrade"
        variant="default"
        class="w-full"
      >
        Upgrade
      </Button>
    </div>
  </div>
</template>